import { InfoOutlined } from '@mui/icons-material'
import { Box, SxProps, Theme, Tooltip, Typography } from '@mui/material'

import { FC } from 'react'

export interface ReadOnlyItemProps {
  /**
   * The class applied to the root element.
   */
  className?: string
  /**
   * The label of the item.
   */
  label: string
  /**
   * If `true`, the value can be shown in multiple lines.
   */
  multiline?: boolean
  /**
   * The value of the item.
   */
  value: string
  /**
   * The text to be displayed in the tooltip. If left empty or undefined, the info icon will not be displayed.
   */
  tooltip?: string

  sx?: SxProps<Theme>

  size?: 'medium' | 'small'

  link?: boolean
}

export const ReadOnlyItem: FC<ReadOnlyItemProps> = ({
  className,
  label,
  value,
  tooltip,
  multiline,
  sx,
  size,
  link,
}) => {
  return (
    <Box className={className} sx={sx}>
      <Box display="flex" alignItems="center">
        <Typography
          variant={size === 'small' ? 'caption' : 'body2'}
          color="textSecondary"
          sx={{
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            textDecoration: 'none',
            marginBottom: 1,
          }}
        >
          {label}
        </Typography>
        {tooltip && (
          <Tooltip title={tooltip} placement="right">
            <InfoOutlined color="primary" sx={{ marginLeft: 3, width: 14, height: 14, marginBottom: 1 }} />
          </Tooltip>
        )}
      </Box>
      <Typography
        component="p"
        variant={size === 'small' ? 'body2' : 'body1'}
        color="textPrimary"
        sx={{
          lineHeight: '1rem',
          whiteSpace: multiline ? 'pre-wrap' : 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          textDecoration: link ? 'underline' : 'none',
        }}
        title={value}
      >
        {value}
      </Typography>
    </Box>
  )
}
